const initialState = {     
    profileId: '',
   questionsAndAnswers: []
}
const governanceReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_QuestionAndAnswers_DATA": return {
        ...state,
        profileId: action.data.profileId,
        questionsAndAnswers: action.data.questionsAndAnswers,
        inputLabel: action.data.questionsAndAnswers.inputLabel,
        helperText: action.data.questionsAndAnswers.helperText
      }
      case "SET_Answers_DATA": {
        const clonedstate = _.cloneDeep(state)
        clonedstate.questionsAndAnswers.forEach(x => {
        const answer = action.data.find(y => y.id === x.id)
        if (answer !== null) {
          x.answer = answer.answer
          x.answerId = answer.answerId
        }
        })
          return {
        ...state,
        questionsAndAnswers: clonedstate.questionsAndAnswers
      }
    }
     default: return state 
    }
  }
  export default governanceReducer